/**
 * Here we put the getters and setters of the indicator storage
 *
 * By default we store the indicator config by pair
 * Once we change something, the configs gets stored also by timeFrame
 */

import { TimeFrame } from '../../screens/Detail/types';
import {
  IndicatorsConfig,
  initialIndicatorsConfig,
} from '../../screens/ProfitCalculations/types';

export const getIndicatorConfig = (
  baseAsset: string,
  quoteAsset: string,
  timeFrame: TimeFrame | undefined,
): IndicatorsConfig => {
  const key = `indicator_config_${baseAsset}_${quoteAsset}`;
  const keyWithTimeFrame = `${key}_${timeFrame}`;

  if (!!timeFrame) {
    const indicatorConfigByTimeFrame = localStorage.getItem(keyWithTimeFrame);

    if (!!indicatorConfigByTimeFrame) {
      return JSON.parse(indicatorConfigByTimeFrame);
    }
  }

  const indicatorConfig = localStorage.getItem(key);

  if (!indicatorConfig) {
    return { ...initialIndicatorsConfig };
  }

  return JSON.parse(indicatorConfig);
};

export const setIndicatorConfigStorage = (
  baseAsset: string,
  quoteAsset: string,
  timeFrame: TimeFrame | undefined,
  indicatorConfig: IndicatorsConfig,
) => {
  const key = `indicator_config_${baseAsset}_${quoteAsset}`;
  const keyWithTimeFrame = `${key}_${timeFrame}`;

  if (!!timeFrame) {
    localStorage.setItem(keyWithTimeFrame, JSON.stringify(indicatorConfig));
    return;
  }

  localStorage.setItem(key, JSON.stringify(indicatorConfig));
};
